import { Home, Users, Clock, User } from "lucide-react";

export const navItems = [
  { icon: Home, labelKey: "nav.home", path: "/" },
  { icon: Users, labelKey: "nav.groups", path: "/groups" },
  { icon: Clock, labelKey: "nav.activity", path: "/activity" },
  { icon: User, labelKey: "nav.profile", path: "/profile" },
];
